export class CompanyEarningConfig {
  Id: string;
  Type: number;
  Name: string;
  IsActive: boolean;
  EmploymentTypeId: number;
  CanHaveRates: boolean;
  CanSetHours: boolean;
  MaxPayAmount: number;
  IsPercentageEarning: boolean;
  IsSourceEarning: boolean;
  IntegrityHash: string;
  SourceEarning: string;
  SourceEarnings: string[];
  CalculationMethod: number;
  SpecialUseEarning: number;
  AppearanceSequence: number;
  DisplayInGrid: boolean;
  IsThirdPartySick: boolean; // TASK 8930
  UseRateFactor: number;
}

export enum EarningCalculations {
  'Fixed Dollar' = 0,
  'Rate' = 1,
  'Shift Differential' = 2,
  'Restaurant OT' = 3,
  'Use Rate From' = 4,
  'Average Rate' = 5,
  'Percentage of Earning' = 6,
  'Boost Fixed' = 7
}

export enum SpecialUseEarning {
  'Other' = 0,
  'Regular' = 1,
  'Salary' = 2
}
